import { render } from "./TextPair.vue?vue&type=template&id=314c36fa&scoped=true"
import script from "./TextPair.vue?vue&type=script&lang=js"
export * from "./TextPair.vue?vue&type=script&lang=js"

import "./TextPair.vue?vue&type=style&index=0&id=314c36fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-314c36fa"

export default script